import { FONTS, COLORS, SPECIALS } from '~/src/common/theme';
import { getMediaQuery } from '~/src/common/theme/deprecated';
import { CSS_FONTS } from '~/src/common/theme/fonts';

const style = `
  ${CSS_FONTS}

  /* App + Pixel de tracking */
  #__next {
    position: relative;
    display: flex;
    flex-direction: column;
    flex: 1;
  }
  #__next ~ img {
    position: absolute;
    top: -100px;
  }

  /* Boxes + Rendu des fonts */
  *,
  *::before,
  *::after {
    box-sizing: border-box;
    text-rendering: optimizeLegibility;
    font-variant-ligatures: no-common-ligatures;
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
    -webkit-tap-highlight-color: transparent;
  }
  html,
  body,
  #root {
    margin: 0;
    height: 100%;
    padding: env(safe-area-inset-top, 0px) 0 env(safe-area-inset-bottom, 0px) 0;
  }

  /* Body + Variantes */
  body {
    display: flex;
    flex-direction: column;
    flex: 1;
    overflow-x: hidden;
    color: ${COLORS.NEUTRAL_DEFAULT};
    background-color: ${COLORS.NEUTRAL_WHITE};
  }
  body.modal-opened {
    overflow: hidden !important;
    position: fixed !important;
  }

  /* Boutons + Inputs */
  [type='reset'],
  [type='submit'] {
    outline: 0;
    cursor: pointer;
    appearance: none;
  }
  input::placeholder {
    color: ${COLORS.NEUTRAL_DISABLED};
    font-family: inherit;
    font-size: 1rem;
  }
  input::-ms-clear {
    width: 0;
    height: 0;
  }
  button {
    cursor: pointer;
    color: inherit;
    font-family: ${FONTS.RETHINK};
  }
  button:disabled {
    cursor: not-allowed;
  }
  *:focus,
  *:focus-within {
    outline: none;
  }

  /* Images + SVG */
  img {
    display: inline-block;
    vertical-align: middle;
    max-width: 100%;
  }
  svg {
    outline: 0;
  }

  /* Liens */
  a {
    line-height: inherit;
    text-decoration: none;
    tap-highlight-color: transparent;
    color: ${COLORS.ACTION_DEFAULT};
  }
  a:hover,
  a:focus {
    text-decoration: none;
    color: ${COLORS.ACTION_HOVER};
  }
  a img {
    border: 0;
  }

  /* Generique */
  pre,
  code {
    font-family: Consolas, Monaco, 'Lucida Console', monospace;
  }
  b {
    font-weight: bold;
  }

  /* Popover */
  .Popover {
    z-index: 50;
  }
  .Popover-body {
    display: inline-flex;
    flex-direction: column;
    background: ${COLORS.NEUTRAL_WHITE};
    box-shadow: ${SPECIALS.SHADOW_NORMAL};
    border-radius: 4px;
  }

  .Popover-tipShape {
    fill: ${COLORS.NEUTRAL_WHITE};
  }

  /* Appsflyer */
  .responsive-wrapper div {
    font-size: 12px;
  }
  @media only ${getMediaQuery(300, 360)} {
    .responsive-wrapper div {
      font-size: 9px;
    }
  }
  @media only ${getMediaQuery(360, 390)} {
    .responsive-wrapper div {
      font-size: 10px;
    }
  }
  @media only ${getMediaQuery(375, null)} {
    .responsive-wrapper div {
      font-size: 12px;
    }
  }
`;

const innerHTML = { __html: `${style}` };
const Main = () => <style dangerouslySetInnerHTML={innerHTML} />;

export default Main;
